import { render, staticRenderFns } from "./channel.vue?vue&type=template&id=09d711fa&scoped=true&"
import script from "./channel.vue?vue&type=script&lang=js&"
export * from "./channel.vue?vue&type=script&lang=js&"
import style0 from "./channel.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./channel.vue?vue&type=style&index=1&id=09d711fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d711fa",
  null
  
)

export default component.exports